import axiosInstance from "api/axiosInstance";

import type { ActivityType, ActivityCategory, ActivityTypeListResponse, ActivityCategoryListResponse, ActivityTypeCreateRequest, ActivityTypeUpdateRequest, ActivityCategoryCreateRequest, ActivityCategoryUpdateRequest, ActivityCategoryDeleteRequest } from "api/types/community-board.types";

// 조회는 앱과 공유하는 공개 엔드포인트(입증된 URL, trailing slash 없음)
const READ_BASE = "/community/api/v1/activity-types";
// 생성/수정/삭제는 어드민 전용 엔드포인트 (docs/커뮤니티_게시판_API_요청서.md 참고)
const ADMIN_BASE = "/community/api/v1/admin/activity-types";

export const communityBoardService = {
  /** 대분류(code) 전체 목록 — 어드민은 diving/other 등 is_active 무관 전체 조회 */
  listTypes: () => axiosInstance.get<ActivityTypeListResponse>(READ_BASE),

  /** 특정 대분류의 하위 카테고리 목록 */
  listCategories: (code: string) => axiosInstance.get<ActivityCategoryListResponse>(`${READ_BASE}/${encodeURIComponent(code)}/categories`),

  /** 대분류 생성 */
  createType: (payload: ActivityTypeCreateRequest) => axiosInstance.post<ActivityType>(`${ADMIN_BASE}/`, payload),

  /** 대분류 수정 */
  updateType: (code: string, payload: ActivityTypeUpdateRequest) => axiosInstance.patch<ActivityType>(`${ADMIN_BASE}/${encodeURIComponent(code)}/`, payload),

  /** 대분류 삭제 (하위 카테고리 + 게시글까지 종속 삭제) */
  removeType: (code: string) => axiosInstance.delete(`${ADMIN_BASE}/${encodeURIComponent(code)}/`),

  /** 하위 카테고리 생성 */
  createCategory: (code: string, payload: ActivityCategoryCreateRequest) => axiosInstance.post<ActivityCategory>(`${ADMIN_BASE}/${encodeURIComponent(code)}/categories/`, payload),

  /** 하위 카테고리 수정 */
  updateCategory: (code: string, categoryCode: string, payload: ActivityCategoryUpdateRequest) => axiosInstance.patch<ActivityCategory>(`${ADMIN_BASE}/${encodeURIComponent(code)}/categories/${encodeURIComponent(categoryCode)}/`, payload),

  /**
   * 하위 카테고리 삭제.
   * 삭제 시 해당 카테고리 게시글을 일괄 삭제(delete_posts)하거나
   * 다른 카테고리로 일괄 이동(move_posts)하는 처리 방식을 body 로 전달한다.
   */
  removeCategory: (code: string, categoryCode: string, body: ActivityCategoryDeleteRequest) => axiosInstance.delete(`${ADMIN_BASE}/${encodeURIComponent(code)}/categories/${encodeURIComponent(categoryCode)}/`, { data: body }),
};
